/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

//import { createSelector } from "@reduxjs/toolkit";
import { AppState } from "..";

export const toastSelector = (state: AppState) => state.helpers.toastDetail;
export const confirmDialogSelector = (state: AppState) => state.helpers.openConfirmDialog;
export const customDialogSelector = (state: AppState) => state.helpers.openCustomDialog;
export const basicDialogSelector = (state: AppState) => state.helpers.basicDialogOpenFor;
export const deviceCountSelector = (state: AppState) => state.helpers.deviceCount;
export const selectedNavListItemsSelector = (state: AppState) => state.helpers.selectedNavListItems;
export const paginationModelSelector = (state: AppState) => state.helpers.paginationModel;
export const dataGridSortSelector = (state: AppState) => state.helpers.sortModel;
export const basicPopoverAnchorElSelector = (state: AppState) => state.helpers.basicPopoverAnchorEl;
export const configAlertCountSelector = (state: AppState) => state.helpers.configAlertCount;
export const notificationCountSelector = (state: AppState) => state.helpers.notificationCount;
export const timeoutDialogSelector = (state: AppState) => state.helpers.openTimeoutDialog;
export const activeTabSelector = (state: AppState) => state.helpers.activeTab;
export const activeMainTabSelector = (state: AppState) => state.helpers.activeMainTab;
export const selectedNavListItemSelector = (state: AppState) => state.helpers.selectedNavListItems.nodeItemIndex;
export const alarmsCountSelector = (state: AppState) => state.helpers.alarmsCount;
export const errorMsgSelector = (state: AppState) => state.helpers.errorMsg;
export const versionDataSelector = (state: AppState) => state.helpers.versionData;
export const isLoadingStatusSelector = (state: AppState) => state.helpers.isLoadingStatus;
export const dataGridRowsSelector = (state: AppState) => state.helpers.dataGridRows;
export const rowModesModelSelector = (state: AppState) => state.helpers.rowModesModel;
export const serverMaintenanceModeSelector = (state: AppState) => state.helpers.serverMaintenanceMode;
